<template>
    <div v-if="offerInfo?.duration" class="d-flex align-center ga-1 pt-8 pb-4">
        <v-icon start size="small" icon="mdi-timer-outline" />
        <div class="">
            {{ `${offerInfo.duration} ${$t('day', offerInfo.duration)}` }}
        </div>
    </div>
    <template v-if="offerInfo?.shortDescription">
        <h6 class="text-h6">{{ $t('description_type.short') }}</h6>
        <div class="pb-4" v-html="offerInfo.shortDescription" />
    </template>
    <template v-if="offerInfo?.fullDescription">
        <h6 class="text-h6">{{ $t('description_type.general') }}</h6>
        <div class="pb-4" v-html="offerInfo.fullDescription" />
    </template>
    <template v-if="offerInfo?.description">
        <h6 class="text-h6">{{ $t('description') }}</h6>
        <div class="pb-4" v-html="offerInfo.description" />
    </template>
    <template v-if="accommodations?.length">
        <TourItineraryDays :accommodations="accommodations" :itinerary-days="offerInfo.itineraryDays" />
    </template>
</template>
<script setup lang="ts">
    import TourItineraryDays from '~/components/account/orderServices/TourItineraryDays.vue'
    import {tourAccommodationMap} from '~/composables/tourAccommodationMap'

    const props = defineProps<{
        offerInfo: any
    }>()

    const accommodations = ref<any[]>([])

    onMounted(async () => {
        if (props.offerInfo?.accommodations?.length)
            accommodations.value = await tourAccommodationMap(props.offerInfo.accommodations)
    })
</script>
